import React from "react";
import "./StartupProjects.css";
import { bigProjects } from "../../portfolio";
import { Fade } from "react-reveal";

export default function StartupProject({ theme }) {
  if (!bigProjects.projects || bigProjects.projects.length === 0) return null;

  function openProjectInNewWindow(url) {
    var win = window.open(url, "_blank");
    win.focus();
  }

  return (
    <div className="main" id="projects">
      <div>
        <Fade bottom duration={1000} distance="20px">
          <h1 className="skills-heading">{bigProjects.title}</h1>
          <p className="subTitle project-subtitle">{bigProjects.subtitle}</p>
        </Fade>
        <div className="startup-projects-main">
          <div className="startup-project-text">
            {bigProjects.projects.map((project, i) => {
              return (
                <div
                  key={i}
                  className="featured-project-card"
                  style={{
                    backgroundColor: theme ? theme.highlight : "#ffffff",
                  }}
                  onClick={() => openProjectInNewWindow(project.link)}
                >
                  <Fade bottom duration={2000} distance="40px">
                    <div
                      style={{
                        width: "100%",
                        height: "100%",
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                      }}
                    >
                      <div className="featured-project-logo-div">
                        <img
                          className="featured-project-logo"
                          alt={project.title}
                          src={require(`../../assets/images/${project.image}`)}
                        />
                      </div>
                      <h3
                        className="featured-project-title"
                        style={{ color: theme ? theme.text : "#000000" }}
                      >
                        {project.title}
                      </h3>
                      <p
                        className="featured-project-description"
                        style={{
                          color: theme ? theme.secondaryText : "#868e96",
                        }}
                      >
                        {project.description}
                      </p>
                    </div>
                  </Fade>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
}
